//API for Chronicles
import { toast } from "react-toastify";
import { ChronicleConstants } from "../_constants";
import { ChronicleService } from "../_services";

//Other Action Creators (for initial loading);
import {
  TimelineActions,
  WorldActions,
  EventActions,
  MapActions,
  MarkerActions,
  ImageActions,
  MarkerTemplatesActions,
  EventTypesActions,
} from "./";

export const ChronicleActions = {
  getChronicle,
  saveChronicle,
  saveChronicleCalendar,
};

function getChronicle(chronicleID, worldID) {
  return (dispatch) => {
    dispatch(request({ chronicleID, worldID }));

    return ChronicleService.loadChronicle({ chronicleID, worldID }).then(
      (chronicle) => {
        const {
          timelines,
          events,
          articles,
          world,
          mapMarkers,
          markerTemplates,
          ...rest
        } = chronicle;
        // console.log('SERVICE', chronicle);
        dispatch(success(rest));
        dispatch(TimelineActions.loadFromChronicle(timelines));
        dispatch(WorldActions.loadFromChronicle(world));
        dispatch(EventActions.getChronicleEvents(chronicle._id));
        dispatch(MapActions.getMapsByChronicle(chronicle._id));
        dispatch(MarkerActions.loadFromChronicle(mapMarkers || []));
        dispatch(ImageActions.getImagesForChronicle(chronicle._id));
        dispatch(MarkerTemplatesActions.loadFromChronicle(markerTemplates));
        dispatch(EventTypesActions.getGlobalEventTypes());
        //dispatch MarkerActions.getChronicleMarkers
        return chronicle;
      },
      (error) => {
        const message = error.toString();
        toast.error(`Unable to retrieve Chronicle.`);
        console.log(`[Chronos] Error - Get Chronicle: `, error);
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: ChronicleConstants.GET_CHRONICLE_REQUEST,
      params,
    };
  }

  function success(chronicle) {
    return {
      type: ChronicleConstants.GET_CHRONICLE_SUCCESS,
      chronicle,
    };
  }

  function failure(error) {
    return {
      type: ChronicleConstants.GET_CHRONICLE_FAILURE,
      error,
    };
  }
}

function saveChronicle(chronicleID, chronicleData) {
  return (dispatch) => {
    dispatch(request({ chronicleID, chronicleData }));

    return ChronicleService.saveChronicle(chronicleID, chronicleData).then(
      (chronicle) => {
        toast.success("Chronicle Updated!");
        // console.log('CHRONOS: Chronicle successfully updated', chronicle);
        dispatch(success(chronicle));
        dispatch(MapActions.getMapsByChronicle(chronicle._id));
        return chronicle;
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Update Chronicle: `, error);
        toast.error(`Unable to save Chronicle changes!`);
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: ChronicleConstants.SAVE_CHRONICLE_REQUEST,
      params,
    };
  }

  function success(chronicle) {
    return {
      type: ChronicleConstants.SAVE_CHRONICLE_SUCCESS,
      chronicle,
    };
  }

  function failure(error) {
    return {
      type: ChronicleConstants.SAVE_CHRONICLE_FAILURE,
      error,
    };
  }
}

function saveChronicleCalendar(calendar) {
  return (dispatch) => {
    // dispatch(request(calendar));

    return ChronicleService.saveChronicleCalendar(calendar).then(
      (result) => {
        // console.log('Calendar Upload', result);
        return result;
        // dispatch(success(result));
      },
      (error) => {
        // console.log('Calendar Upload Error', error);
        // dispatch(failure(error.toString()))
      }
    );
  };
}
